<template>
  <div>
    <NuxtLoadingIndicator />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <UNotifications />
  </div>
</template>

<script setup lang="ts">
const { locale } = useI18n();

useHead(() => ({
  htmlAttrs: {
    dir: locale.value === 'ar' ? 'rtl' : 'ltr',
    lang: locale.value,
  },
}));

// stop zooming
function preventZoom(event: any) {
  if (event.ctrlKey) {
    if (event.key === '+' || event.key === '-' || event.key === '=') {
      event.preventDefault();
    }
  }
}

function preventWheelZoom(event: any) {
  if (event.ctrlKey) {
    event.preventDefault();
  }
}

onMounted(() => {
  window.addEventListener('wheel', preventWheelZoom, { passive: false });
  window.addEventListener('keydown', preventZoom);
});

onUnmounted(() => {
  window.removeEventListener('wheel', preventWheelZoom);
  window.removeEventListener('keydown', preventZoom);
});
</script>

<style lang="scss">
body {
  zoom: 1;
}
// Transitions
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.popup-enter-active,
.popup-leave-active {
  transition: 0.28s ease-in-out;
  transform: scale(1);
}
.popup-enter-from,
.popup-leave-to {
  transform: scale(0.8);
}

// Scrollbar
.scrollbar {
  &::-webkit-scrollbar {
    width: 5px;
    scrollbar-width: thin;
  }
  &::-webkit-scrollbar-track {
    background: #b0b2b6;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #1ed760;
    border-radius: 8px;
  }
}

.v-input--density-default {
  --v-input-control-height: 20px;
  --v-input-padding-top: 0;
}
.v-selection-control--density-default {
  --v-selection-control-size: 30px;
}

.v-selection-control__wrapper {
  height: 36px;
}

.loader {
  width: 50px;
  aspect-ratio: 1;
  display: grid;
}
.loader::before,
.loader::after {
  content: '';
  grid-area: 1/1;
  --c: no-repeat radial-gradient(farthest-side, #1ed760 92%, #0000);
  background:
    var(--c) 50% 0,
    var(--c) 50% 100%,
    var(--c) 100% 50%,
    var(--c) 0 50%;
  background-size: 12px 12px;
  animation: l12 1s infinite;
}
.loader::before {
  margin: 4px;
  filter: hue-rotate(45deg);
  background-size: 8px 8px;
  animation-timing-function: linear;
}

@keyframes l12 {
  100% {
    transform: rotate(0.5turn);
  }
}
</style>
